import { render, staticRenderFns } from "./order_detailed_view.vue?vue&type=template&id=64e6e629&scoped=true&"
import script from "./order_detailed_view.vue?vue&type=script&lang=ts&"
export * from "./order_detailed_view.vue?vue&type=script&lang=ts&"
import style0 from "./order_detailed_view.vue?vue&type=style&index=0&id=64e6e629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6e629",
  null
  
)

export default component.exports